export type MonitorFilterOption = {
  value: string;
  label: string;
  keywords?: string[];
};

export type MonitorFilterGroup = {
  id: string;
  label: string;
  options: MonitorFilterOption[];
};

export const monitorFilterGroups: MonitorFilterGroup[] = [
  {
    id: 'brand',
    label: 'Thương hiệu',
    options: [
      { value: 'dell', label: 'DELL', keywords: ['dell'] },
      { value: 'samsung', label: 'SAMSUNG', keywords: ['samsung'] },
      { value: 'vsp', label: 'VSP', keywords: ['vsp'] },
      { value: 'aoc', label: 'AOC', keywords: ['aoc'] },
      { value: 'asus', label: 'ASUS', keywords: ['asus'] },
      { value: 'gigabyte', label: 'GIGABYTE', keywords: ['gigabyte'] },
      { value: 'hp', label: 'HP', keywords: ['hp'] },
      { value: 'msi', label: 'MSI', keywords: ['msi'] },
      { value: 'lg', label: 'LG', keywords: ['lg'] },
      { value: 'viewsonic', label: 'VIEWSONIC', keywords: ['viewsonic', 'view sonic'] },
      { value: 'philips', label: 'PHILIPS', keywords: ['philips'] },
      { value: 'edra', label: 'EDRA', keywords: ['edra'] },
      { value: 'lc-power', label: 'LC POWER', keywords: ['lc power', 'lc-power'] },
      { value: 'hkc', label: 'HKC', keywords: ['hkc'] },
      { value: 'dahua', label: 'DAHUA', keywords: ['dahua'] },
      { value: 'lenovo', label: 'LENOVO', keywords: ['lenovo'] },
      { value: 'ktc', label: 'KTC', keywords: ['ktc'] },
    ],
  },
  {
    id: 'size',
    label: 'Kích thước',
    options: [
      { value: '22-inch', label: '22 inch', keywords: ['22 inch', '22"', '21.5 inch', '21.5"'] },
      { value: '24-inch', label: '24 inch', keywords: ['24 inch', '24"', '23.8 inch', '23.8"'] },
      { value: '27-inch', label: '27 inch', keywords: ['27 inch', '27"'] },
      { value: '32-inch', label: '32 inch', keywords: ['32 inch', '32"', '31.5 inch', '31.5"'] },
      { value: '34-inch', label: '34 inch', keywords: ['34 inch', '34"'] },
    ],
  },
  {
    id: 'resolution',
    label: 'Độ phân giải',
    options: [
      { value: 'hd', label: 'HD', keywords: ['hd', '720p', '1366 768', '1366x768'] },
      { value: 'hd-plus', label: 'HD+', keywords: ['hd+', 'hd plus', '1600 900', '1600x900'] },
      {
        value: 'full-hd',
        label: 'Full HD',
        keywords: ['full hd', 'fhd', '1080p', '1920 1080', '1920x1080'],
      },
      {
        value: 'uwhd',
        label: 'UWHD',
        keywords: ['uwhd', 'ultra wide hd', 'ultrawide hd', '2560 1080', '2560x1080'],
      },
      { value: 'wuxga', label: 'WUXGA', keywords: ['wuxga', '1920 1200', '1920x1200'] },
      { value: 'qhd', label: 'QHD', keywords: ['qhd', '2k', '1440p', '2560 1440', '2560x1440'] },
      { value: 'wqhd', label: 'WQHD', keywords: ['wqhd', 'wide qhd', '3440 1440', '3440x1440'] },
      {
        value: 'dualqhd',
        label: 'DualQHD',
        keywords: ['dualqhd', 'dual qhd', '5120 1440', '5120x1440'],
      },
      { value: '4k', label: '4K', keywords: ['4k', 'uhd', '2160p', '3840 2160', '3840x2160'] },
    ],
  },
  {
    id: 'refresh-rate',
    label: 'Tần số quét',
    options: [
      { value: '60hz', label: '60Hz', keywords: ['60hz', '60 hz'] },
      { value: '75hz', label: '75Hz', keywords: ['75hz', '75 hz'] },
      { value: '100hz', label: '100Hz', keywords: ['100hz', '100 hz'] },
      { value: '120hz', label: '120Hz', keywords: ['120hz', '120 hz'] },
      { value: '144hz', label: '144Hz', keywords: ['144hz', '144 hz'] },
      { value: '165hz', label: '165Hz', keywords: ['165hz', '165 hz'] },
      { value: '240hz', label: '240Hz', keywords: ['240hz', '240 hz'] },
    ],
  },
  {
    id: 'panel-type',
    label: 'Tấm nền',
    options: [
      { value: 'ips', label: 'Màn Hình IPS', keywords: ['ips', 'man hinh ips'] },
      { value: 'pls', label: 'Màn Hình PLS', keywords: ['pls', 'man hinh pls'] },
      { value: 'va', label: 'Màn Hình VA', keywords: ['va', 'man hinh va'] },
      { value: 'tn', label: 'Màn Hình TN', keywords: ['tn', 'man hinh tn'] },
    ],
  },
  {
    id: 'usage',
    label: 'Nhu cầu',
    options: [
      { value: 'flat', label: 'Màn hình phẳng', keywords: ['man hinh phang', 'flat'] },
      { value: 'curved', label: 'Màn hình cong', keywords: ['man hinh cong', 'curved'] },
      {
        value: 'graphic-design',
        label: 'Thiết kế đồ họa',
        keywords: ['thiet ke do hoa', 'do hoa', 'designer', 'design'],
      },
      { value: 'gaming', label: 'Gaming', keywords: ['gaming', 'game'] },
      { value: 'office', label: 'Văn phòng', keywords: ['van phong', 'office'] },
    ],
  },
  {
    id: 'response-time',
    label: 'Thời gian phản hồi',
    options: [
      { value: '1ms-gtg', label: '1ms (GTG)', keywords: ['1ms', '1 ms', '1ms gtg', '1 ms gtg'] },
      { value: '2ms-gtg', label: '2ms (GTG)', keywords: ['2ms', '2 ms', '2ms gtg', '2 ms gtg'] },
      { value: '3ms-gtg', label: '3ms (GTG)', keywords: ['3ms', '3 ms', '3ms gtg', '3 ms gtg'] },
      { value: '4ms-gtg', label: '4ms (GTG)', keywords: ['4ms', '4 ms', '4ms gtg', '4 ms gtg'] },
      { value: '5ms-gtg', label: '5ms (GTG)', keywords: ['5ms', '5 ms', '5ms gtg', '5 ms gtg'] },
      { value: '8ms-gtg', label: '8ms (GTG)', keywords: ['8ms', '8 ms', '8ms gtg', '8 ms gtg'] },
      {
        value: '10ms-gtg',
        label: '10ms (GTG)',
        keywords: ['10ms', '10 ms', '10ms gtg', '10 ms gtg'],
      },
      {
        value: '12ms-gtg',
        label: '12ms (GTG)',
        keywords: ['12ms', '12 ms', '12ms gtg', '12 ms gtg'],
      },
    ],
  },
];
